/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Australia_Sydney2Inputs */

const he_timezone_australia_sydney2 = /** @type {(inputs: Timezone_Australia_Sydney2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sydney`)
};

const en_timezone_australia_sydney2 = /** @type {(inputs: Timezone_Australia_Sydney2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sydney`)
};

/**
* | output |
* | --- |
* | "Sydney" |
*
* @param {Timezone_Australia_Sydney2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_australia_sydney2 = /** @type {((inputs?: Timezone_Australia_Sydney2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Australia_Sydney2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_australia_sydney2(inputs)
	return en_timezone_australia_sydney2(inputs)
});
export { timezone_australia_sydney2 as "timezone_Australia_Sydney" }